/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolScheduleIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-schedule"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M13.35 11.45L13.35 8.22Q13.35 7.67 12.96 7.29Q12.57 6.9 12.03 6.9Q11.47 6.9 11.09 7.29Q10.7 7.67 10.7 8.22L10.7 12Q10.7 12.28 10.8 12.51Q10.9 12.75 11.1 12.95L14.22 16.07Q14.6 16.45 15.14 16.46Q15.68 16.48 16.07 16.07Q16.45 15.7 16.46 15.15Q16.48 14.6 16.1 14.22ZM12 22.8Q9.75 22.8 7.79 21.95Q5.83 21.1 4.36 19.64Q2.9 18.18 2.05 16.21Q1.2 14.25 1.2 12Q1.2 9.75 2.05 7.78Q2.9 5.8 4.36 4.34Q5.83 2.88 7.79 2.04Q9.75 1.2 12 1.2Q14.25 1.2 16.23 2.04Q18.2 2.88 19.66 4.34Q21.13 5.8 21.96 7.78Q22.8 9.75 22.8 12Q22.8 14.25 21.96 16.21Q21.13 18.18 19.66 19.64Q18.2 21.1 16.23 21.95Q14.25 22.8 12 22.8Z" fill={color} />
    </svg>
  );
}
